import styled from 'styled-components'

import Flex from 'Components/Flex'
import { Col } from 'react-styled-flexboxgrid-tmp'


export const _PreviewSliderSection = styled(Flex)`
  margin: 32px 
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  transform: translateZ(0px);
  transform: translate3d(0,0,0);
  perspective: 1000;
  
  ${({ isBuilding }) => (isBuilding && `
    > a > div {
      height: auto;
      flex-shrink: 0;
      width: 270px;
      padding: 0 5px;
    }
    > a {
      position: relative;
      }
  `)};
  @media screen and (max-width: 1024px) {
    > div {
      max-width: 270px;
      flex-basis: 100%;
    }
  }

`

export const _Slide = styled(Col)`
  flex-shrink: 0;
  width: 270px;

  padding: ${({ isBuilding }) => (isBuilding ? '0 5px' : '0')};

  @media screen and (max-width: 1024px) {
    max-width: 270px;
  }
`
